import moment from 'moment';

export const getTodayAt0Hours = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

export const toLocalISOString = (date: Date) => {
  let month = '' + (date.getMonth() + 1),
    day = '' + date.getDate(),
    year = date.getFullYear();

  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }

  return [year, month, day].join('-');
};

export const formatDateForZen = (date: Date) =>
  moment(date).format('YYYY-MM-DD');
